import { usingPut, usingDelete } from '@ocean/api'

export const keepSessionAlive = () => usingPut(`Session/KeepAlive`, null, { useProxy: true })

export const logout = () => usingDelete(`Session/Logout`, null, { useProxy: true })
